import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { MasterSummaryPDModel, MasterSummaryQuestionModel } from '../../../../../models/survey/survey.model';
import { SortType } from '../../../../../shared/constants/sort.constants';

@Component({
  selector: 'app-sort-icon',
  templateUrl: './sort-icon.component.html',
  styleUrls: ['./sort-icon.component.less']
})
export class SortIconComponent implements OnInit {
  @Output() onUpdatedSort = new EventEmitter<string>();
  @Input() isCompareMode: boolean;
  @Input() isPercentedEnable: boolean;
  @Input() question: MasterSummaryQuestionModel;  
  @Input("surveyMasterSummaryPDModel") survMastSummPDModel: MasterSummaryPDModel;

  showDropdownSort = false;
  private listening = false;
  private globalClick: any;

  constructor() { }

  ngOnInit() {
  }

  displayDropdownSort(element) {
    this.showDropdownSort = !this.showDropdownSort;
    if (this.showDropdownSort) {
      this.globalClick = Observable
        .fromEvent(document, 'click')
        .delay(100)
        .do(() => {
          this.listening = true;
        }).subscribe((event: MouseEvent) => {
          this.onGlobalClick(element, event);
        });
    } else {
      this.listening = false;
      this.globalClick.unsubscribe();
    }
  }

  onGlobalClick(element, event: MouseEvent) {
    if (event instanceof MouseEvent && this.listening === true) {
      if (!this.isDescendant(element.target, event.target)) {
        this.showDropdownSort = false;
        this.listening = false;
        this.globalClick.unsubscribe();
      }
    }
  }

  isDescendant(parent, child) {
    let node = child;
    while (node !== null) {
      if (node === parent) {
        return true;
      } else {
        node = node.parentNode;
      }
    }
    return false;
  }

  selectedSort(_sortType: string){
    this.onUpdatedSort.emit(_sortType)
  }

  get SortType(): typeof SortType {
    return SortType
  }
}





// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/icon-dropdown/sort-icon/sort-icon.component.ts